import React from 'react';

export default function Personality({ nextStep, prevStep, maxSteps, step }) {
  return (
    <div className='container mt-5'>
      <div className='footer'>
        <button className='navigate' disabled={step === 0} onClick={prevStep}>
          Prev
        </button>
        <button
          className='navigate'
          disabled={step === maxSteps}
          onClick={nextStep}
        >
          Next
        </button>
      </div>
    </div>
  );
}
